<template>
  <div>

    <EmptyModal :onModalClose="closeModal" :modalData="modalData" v-if="modalData">
      <slot>
        <img class="w-100" :src="modalData.source" alt="">
      </slot>
    </EmptyModal>

    <label for="filesUpload" v-if="!blockUpload">
      <span type="button" class="btn btn-outline-info">Выбрать файлы для загрузки</span>
    </label>
    <input type="file" ref="file"
           id="filesUpload"
           class="hidden"
           @change="readMultiFiles"
           accept="image/x-png,image/gif,image/jpeg,application/pdf"
           multiple="multiple">
    <div class="flex flex-wrap">
      <div v-bind:class="{'img_div': true, 'img_small_div': smallPhotos}" v-for="(img, i) in uploadedFiles"
           v-if="!img.to_delete && !img.type" :key="i">
        <button v-if="allowToDelete" @click="removeFile(i)" type="button" class="btn del_btn btn-danger btn-xs"><i
          class="icon-fa icon-fa-trash"/></button>
        <template v-if="img.source">
          <img @click="openImage(img)" class="imagePreviewWrapper pointer" :src="img.source" alt="">
        </template>
        <template v-else>
          <div class="flex files_preview justify-content-center align-items-center">
            <LoadingButton
              title="Показать фото"
              className="btn btn-outline-success btn-xs"
              :onClick="() => loadImage(i)"
              :loading="loadingImage[img.id]"
              :color="$constants.SUCCESS_COLOR"
              type="button"
            />
          </div>
        </template>
        <div v-if="img.details" class="img_details text-right text-muted pr-1">
          <span v-if="!showImages && !img.is_active" class="badge badge-warning">файл удален</span>
          ({{ img.details.uploaded_by.user_name }}) {{ printDate(img.created_at, 'DD.MM.YYYY HH:mm') }}
        </div>
      </div>
    </div>
    <div>
      <div v-for="(f, i) in uploadedFiles" v-if="f.type === 4" class="flex flex_gap_10 mb-1">
        <LoadingButton
          title="скачать"
          className="btn btn-outline-success btn-xs"
          :onClick="() => downloadFile(f)"
          :loading="loadingImage[f.id]"
          :color="$constants.SUCCESS_COLOR"
          type="button"
        />
        <span><strong>СДЭК Стикер</strong> {{ printDate(f.created_at) }}</span>
      </div>
    </div>
  </div>
</template>

<script>

import api from '@/api'
import LoadingButton from "@/components/buttons/LoadingButton";
import EmptyModal from "@/components/modals/EmptyModal";

export default {
  components: {
    LoadingButton,
    EmptyModal,
  },
  props: ['files', 'showImages', 'smallPhotos', 'blockUpload', 'allowToDelete'],
  data() {
    return {
      modalData: null,
      uploadedFiles: [],
      loadingImage: {},
    }
  },
  mounted() {
    if (this.files && this.files.length) {
      this.loadingImage = this.files.reduce((acc, f, i) => {
        acc[f.id] = false;
        return acc;
      }, {})
      this.uploadedFiles = this.files.map((f) => {
        return {...f, source: null}
      })
    }
    if (this.showImages) {
      this.uploadedFiles.forEach(async (f, i) => {
        await this.loadImage(i);
      })
    }
  },
  methods: {
    async downloadFile(file) {
      this.loadingImage[file.id] = true;
      const {data} = await api.index('new/files/download/' + file.id);
      if (data.success) {
        window.location.href = data.link;
      } else {
        toastr['warning'](data.message || 'Ошибка загрузки файла');
      }
      this.loadingImage[file.id] = false;
    },
    closeModal() {
      this.modalData = null;
    },
    openImage(img) {
      this.modalData = {source: img.source, disableFooter: false}
    },
    async loadImage(i) {
      this.loadingImage[i] = true;
      const {data} = await api.index('uploads/getImgLinkByKey?key=' + this.uploadedFiles[i].path);
      if (data.success) {
        this.uploadedFiles[i].source = data.link;
      } else {
        toastr['warning'](data.message || 'Ошибка загрузки файла');
      }
    },
    readMultiFiles(e) {
      const files = e.currentTarget.files;

      function setup_reader(file, vm) {
        var name = file.name;
        var reader = new FileReader();
        reader.onload = function (e) {
          vm.uploadedFiles.push({
            source: e.target.result,
            file_name: name,
            extension: name.split('.').slice(-1)[0],
            to_delete: false,
          })
        }
        reader.readAsDataURL(file);
      }

      for (var i = 0; i < files.length; i++) {
        setup_reader(files[i], this);
      }
    },
    removeFile(index) {
      this.uploadedFiles[index].to_delete = true;
      this.uploadedFiles = [...this.uploadedFiles];
    },
  }
}

</script>

<style scoped>
.img_div.img_small_div {
  width: calc(25% - 5px);
}

.img_div {
  /*width: 240px;*/
  width: calc(50% - 5px);
  min-height: 75px;
  position: relative;
  border: 1px solid lightgrey;
  margin-right: 5px;
  margin-bottom: 5px;
}

.img_div img {
  width: 100%;
  /*width: 238px;*/
}

.img_div .form-control {
  border-radius: 0;
}

.img_div .del_btn i {
  text-align: center;
}

.files_preview {
  height: 75px;
}

.img_div .del_btn {
  position: absolute;
  right: 5px;
  top: 5px;
}

.img_details {
  font-size: 12px;
}
</style>
